module.exports = __webpack_public_path__ + "img/art2.07143ff7.svg";